import { render, staticRenderFns } from "./orderTake.vue?vue&type=template&id=3f4b55c8&scoped=true"
import script from "./orderTake.vue?vue&type=script&lang=js"
export * from "./orderTake.vue?vue&type=script&lang=js"
import style0 from "./orderTake.vue?vue&type=style&index=0&id=3f4b55c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b55c8",
  null
  
)

export default component.exports